import _ from "lodash";
/**-- external -- */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

/**-- internal -- */
import { useI18n } from "Hooks";
import {
  getCurriculumProgramFreeStatus,
  selectedAcademicYearSelector,
} from "Platform/modules/PlatformModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getOrganizationDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { checkIsToddleV2TimetableEnabled } from "AttendanceDashboard/modules/Utils";
import { getSelectedCurriculumProgramIds } from "HomePage/modules/HomePageUtils";
import {
  getIsFutureAcademicYearSelected,
  getIsCurrentAcademicYearSelected,
  getCurrentCurriculumContextForJumpTo,
} from "modules/CommonSelectors";

import { getIsAdminByRole } from "lib/staffPermissionUtils";

/**-- relative -- */
import classes from "./HomepageFeatures.scss";
import { HomepageFeatureCard } from "./components";
import { getHomePageFeaturesV2 } from "AppComponents/GlobalSearchBarV2/components/Utils";
import { HeadingText } from "../../commonComponents";
import { getIsGlobalSearchJumpToRevampEnabled } from "GlobalHeader/modules/Utils";

const HomepageFeatures = props => {
  const {
    testId,
    homePageFeatures,
    userType,
    organizationId,
    onNavigationDone,
    updateAvailableHomepageFeatures,
    columnIndex,
    currentCurriculumProgramId,
  } = props;

  const { t } = useI18n(["common"]);

  const localTestId = `${testId}-modulesFeed`;

  /**
   * Side effect to update available homepage features shortcuts
   */
  useEffect(() => {
    updateAvailableHomepageFeatures(homePageFeatures);
  }, [homePageFeatures]);

  const headerClasses = classNames(classes.header, "text-label-4");

  const isGlobalSearchJumpToRevampEnabled = getIsGlobalSearchJumpToRevampEnabled();

  const containerClasses = isGlobalSearchJumpToRevampEnabled
    ? classes.containerV2
    : classes.container;

  const featuresContainerClasses = isGlobalSearchJumpToRevampEnabled
    ? classes.featuresContainerV2
    : classes.featuresContainer;

  return (
    <div className={containerClasses}>
      {isGlobalSearchJumpToRevampEnabled ? (
        <HeadingText text={t("common:modules")} />
      ) : (
        <div className={headerClasses}>{t("common:modules")}</div>
      )}
      <div className={featuresContainerClasses}>
        {_.map(homePageFeatures, feature => (
          <HomepageFeatureCard
            key={feature}
            feature={feature}
            testId={localTestId}
            userType={userType}
            organizationId={organizationId}
            onNavigationDone={onNavigationDone}
            columnIndex={columnIndex}
            currentCurriculumProgramId={currentCurriculumProgramId}
          />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const currentCurriculumContext = getCurrentCurriculumContextForJumpTo(state);

  const tabConfigurations = {
    admin: currentCurriculumContext,
    teacher: currentCurriculumContext,
  };

  const isCurriculumProgramFree = getCurriculumProgramFreeStatus({
    state,
    tabConfigurations,
  });

  const userInfo = getUserInfo();
  const {
    id: userId,
    org_id: organizationId,
    user_type: userType,
    identityId,
    role,
  } = userInfo;

  const organizationDetails = getOrganizationDetailsFromCache(organizationId);

  const organizationTags = _.get(organizationDetails, "tags", []);

  const isFutureAcademicYearSelected = getIsFutureAcademicYearSelected(state);
  const isCurrentAcademicYearSelected = getIsCurrentAcademicYearSelected(state);

  const academicYearSelected = selectedAcademicYearSelector(state);

  const isAdmin = getIsAdminByRole();

  const {
    userCurriculumPrograms,
    homeroomStudentCount,
    totalNewSnpCycles,
  } = ownProps;

  const {
    id: currentCurriculumProgramId,
    type: currentCurriculumProgramType,
  } = currentCurriculumContext;

  const isToddleV2TimetableEnabled = checkIsToddleV2TimetableEnabled();
  const curriculumProgramIds = getSelectedCurriculumProgramIds(state);

  const homePageFeatures = getHomePageFeaturesV2({
    isCurriculumProgramFree,
    userId,
    userType,
    organizationId,
    organizationTags,
    isFutureAcademicYearSelected,
    isCurrentAcademicYearSelected,
    academicYearSelected,
    isAdmin,
    userCurriculumPrograms,
    currentCurriculumProgramId,
    currentCurriculumProgramType,
    homeroomStudentCount,
    totalNewSnpCycles,
    identityId,
    role,
    isToddleV2TimetableEnabled,
    curriculumProgramIds,
  });

  return {
    homePageFeatures: _.map(homePageFeatures, ({ key }) => key),
    userType,
    organizationId,
  };
};

export default connect(mapStateToProps)(HomepageFeatures);
